import type Api from '~/types';
import TooltipGameReward from '~/Components/TooltipGameReward/TooltipGameReward';
import { settings } from '~/Components/DownloadGamePopup/settings';

type RewardCountType = {
    reward: Api.IReward,
    index?: number,
};

const RewardCount = (props: RewardCountType) => {
    const { reward } = props;

    const index = props.index || 0;

    const gameReward = reward.gameRewards[index];

    return (
        <TooltipGameReward
            imgSrc={reward.isMainReward && settings.isPublicTestMode ? reward.extraImage : reward.image}
            {...gameReward}
            hideText
            withAmount
        />
    );
};

export default RewardCount;
